<template>
    <ion-list>
        <ion-list-header>
            <ion-label>
                {{ file.name }}
                <ion-badge slot="end">{{ file.readable_size }}</ion-badge>
            </ion-label>
        </ion-list-header>
        <ion-item v-if="file.type === 'Attachment'" :button="!file.is_from_own_vault">
            <ion-button v-if="file.is_from_own_vault" fill="clear" disabled style="color: #007900;">
                <ion-icon slot="start" md="shield-checkmark" ios="shield-checkmark"/>
                {{ $t('ncrypt.vault.popover_file_is_in_vault') }}
            </ion-button>
            <ion-button v-else-if="isBeingMovedToFault" fill="clear" disabled style="color: #007900;">
                <ion-icon slot="start" md="shield" ios="shield"/>
                {{ $t('ncrypt.vault.popover_file_added_to_vault') }}
            </ion-button>
            <ion-button v-else @click="saveToVault" fill="clear" style="color: black;">
                <ion-icon slot="start" md="shield" ios="shield"></ion-icon>
                {{ $t('ncrypt.vault.popover_add_file_to_vault') }}
            </ion-button>
        </ion-item>
        <ion-item v-if="file.type === 'VaultFile' || file.is_from_own_vault" button>
            <ion-button @click="sendAsMessage" fill="clear" style="color: black;">
                <ion-icon slot="start" md="send" ios="send"></ion-icon>
                {{ $t('ncrypt.vault.popover_add_as_attachment_to_message') }}
            </ion-button>
        </ion-item>
        <ion-item button>
            <ion-button @click="download" fill="clear" style="color: black;" :title="file.name">
                <ion-icon slot="start" md="download" ios="download"></ion-icon>
                {{ $t('ncrypt.vault.popover_download_file') }}
            </ion-button>
        </ion-item>
    </ion-list>
</template>

<script>
    import {Notifier} from "../../services/Notifier";
    import {ApiError} from "../../errors/ApiError";
    import {FileDownloader} from "../../services/FileDownloader";

    export default {
        name: "FilePopover",
        props: {
            file: {type: Object},
        },
        data() {
            return {
                isBeingMovedToFault: false,
            }
        },
        methods: {
            async close() {
                await this.$ionic.popoverController.dismiss();
            },
            download() {
                FileDownloader.downloadFile(this.file.url, this.file.name)
                    .then(() => this.close());
            },
            async saveToVault() {
                if (!this.$store.getters.authed) {
                    await this.close();

                    await Notifier.showAlert({
                        header: this.$t('ncrypt.login_or_register'),
                        message: this.$t('ncrypt.vault.save_to_vault_possible_after_auth'),
                        buttons: ['OK'],
                    });
                    return;
                }

                this.$http.post(`/vault/add-from-attachment/${this.file.id}`)
                    .then(async (response) => {
                        if (response.status !== 200) {
                            new ApiError(response);
                            return;
                        }

                        this.isBeingMovedToFault = true;

                        // TODO: update future popovers to show that it is (being) moved to the vault

                        await this.close();

                        await Notifier.showToast({
                            message: this.$t('ncrypt.vault.file_is_being_added'),
                        });
                    })
                    .catch(reason => new ApiError(reason));
            },
            async sendAsMessage() {
                await this.close();

                await this.$router.push({
                    name: 'writeMessage',
                    query: {vaultFiles: [this.file]},
                });
            },
        },
    }
</script>

<style lang="scss">
    .file-popover {
        --width: 380px;

        ion-list-header {

            ion-label {
                font-weight: bold;
            }
        }
    }

    .file-download-alert {
        .alert-wrapper {
            --min-width: 400px;
        }
    }
</style>
